import { FunctionComponent, useContext, useState } from "react";
import FilterTitle from "./FilterTitle";
import styles from "./FilterDropdown.module.css";
import images from "../../../../assets/images/index";
import "react-datepicker/dist/react-datepicker.css";
import { useLazyQuery } from "@apollo/client";
import { GET_LEAGUES_LIST } from "../../../../features/Tickets/api/TicketsQuery";
import { DateFilter, LeagueListMenu, ResetApplyButtons, convertStringToDate, extractLeagues, formatDateWithHyphen, showCustomRange } from "../../../../helper";
import { globalContext } from "../../../../Provider/AppProvider";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

interface FilterDropdownProps {
  activetab ?: number
  handleCloseFilterDropDown: () => void
}

interface LeagueObjectType{
  l_id: string,
  l_name: string,
}
interface LeaguesList{
    leagues: LeagueObjectType[]
}
const ListTicketFilterDropdown: FunctionComponent<FilterDropdownProps> = ({handleCloseFilterDropDown}) => {
  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  const [listFilterStartDate,setlistFilterStartDate] = useState<string | null>(null);
  const [listFilterEndDate, setlistFilterEndDate] = useState<string | null>(null);
  const [listFilterStartDateRange,setlistFilterStartDateRange] = useState<string | null>(null);
  const [listFilterEndDateRange, setlistFilterEndDateRange] = useState<string | null>(null);
  const [listFilterLeagueId,setlistFilterLeagueId] = useState<string | null>(globalState.listTicketFilter.leagueId || null);
  const [valueradio, setValueRadio] = useState<string | null>(globalState.listTicketFilter.ticketStatus ? globalState.listTicketFilter.ticketStatus : null);
  const {dropdownIcon} = images;
  const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null);
  const [listLeague , setlistLeague] = useState<string>(globalState.listTicketFilter.leagueName || "")
  const [days, setDays] = useState<string>(globalState.listTicketFilter.selectedDateValue || "")
  const [startDatelist, setStartDatelist] = useState<any>('');
  const [endDatelist, setEndDatelist] = useState<any>('');
  const [showDatePickerlist, setShowDatePickerlist] = useState<boolean>(false);
  const [customRangelist, setCustomrangelist] = useState<boolean>(false);

const [leagueslistDataInlist,setLeaguesListInlist] = useState<LeaguesList>();

  const [getLeaguesListForlistFilter] = useLazyQuery(GET_LEAGUES_LIST, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if(data){
        const extractedData = data?.leagues
        ?.filter((item: LeagueObjectType) => !extractLeagues.includes(item?.l_name))
        .map((result:LeagueObjectType) => result);
        setLeaguesListInlist(extractedData);
      }
    }
   });

  const handleClickOpenMenu = (e: React.MouseEvent<HTMLInputElement>) =>{
    setAnchorEl(e.currentTarget);
    getLeaguesListForlistFilter();
  }

  const handleCloseMenu = ()=>{
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);

  const handleSelectleague = (league: LeagueObjectType) =>{
    setlistLeague(league?.l_name);
    setlistFilterLeagueId(league?.l_id);
    setAnchorEl(null)
  }

  const handleChangeValidate = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValueRadio(event.target.value);
  };

  const handleCancel = () =>{
    const tempData = {...globalState};
    tempData.listTicketFilter.isFilter = false;
    tempData.listTicketFilter.leagueId = null;
    tempData.listTicketFilter.leagueName = '';
    tempData.listTicketFilter.ticketStatus = null;
    tempData.listTicketFilter.startdate = null;
    tempData.listTicketFilter.enddate = null;
    tempData.listTicketFilter.startDateRange = null;
    tempData.listTicketFilter.endDateRange = null;
    tempData.listTicketFilter.selectedDateValue = '';
    tempData.listTicketFilter.isCustomRange = false;
    tempData.listTicketFilter.clicked = true;

    handleGlobalState(tempData);
    setlistLeague("")
    setDays("")
    setValueRadio(null);
    setStartDatelist("");
    setEndDatelist("");
    setlistFilterStartDate(null);
    setlistFilterEndDate(null);
    setlistFilterStartDateRange(null);
    setlistFilterEndDateRange(null);
    setlistFilterLeagueId(null);
    setShowDatePickerlist(false)
    setCustomrangelist(false)
  }

  const handleClickDays = (day: string) =>{
    setStartDatelist('');
    setEndDatelist('');
    setlistFilterStartDateRange(null);
    setlistFilterEndDateRange(null);
    const {startdate,enddate} = convertStringToDate(day);
    setlistFilterStartDate(startdate);
    setlistFilterEndDate(enddate);
    setDays(day);
  }

  const listDatePickerChange = (dates: [start: Date,end: Date]) => {
    const [start, end] = dates; 
    setlistFilterStartDate(null);
    setlistFilterEndDate(null);
    setlistFilterStartDateRange(start  && formatDateWithHyphen(start));
    setlistFilterEndDateRange(end && formatDateWithHyphen(end));
    setStartDatelist(start);
    setEndDatelist(end);
    setDays('')
    setCustomrangelist(false)
  };

  const handleClicklistCustomRange = () =>{
    setShowDatePickerlist(true)
    setDays('')
    setCustomrangelist(false);
  }

  const handleClicklistDatePickerOutside = () =>{
    setShowDatePickerlist(false)
    setCustomrangelist(true)
    setDays('')
    if(endDatelist === null){
      setlistFilterEndDateRange(startDatelist && formatDateWithHyphen(startDatelist));
      setEndDatelist(startDatelist)
    }
  }

const showDayTick = () => {
  if(listFilterStartDateRange && listFilterEndDateRange){
    return '';
  }else {
    if(days === '' && globalState.listTicketFilter.selectedDateValue === ''){
      return '';
    }else if(days){
      return days;
    }else if(globalState.listTicketFilter.selectedDateValue){
      return globalState.listTicketFilter.selectedDateValue;
    }
  }
}

const showCustomRangeValues = () => {
  if(listFilterStartDate){
     return '';
  }else {
    if(customRangelist === false && globalState.listTicketFilter.isCustomRange === false){
      return;
     }else if(customRangelist){
       return (<span className={styles.dateformat}>{showCustomRange(startDatelist,endDatelist,"list",globalState)}</span>);
     }else if(globalState.listTicketFilter.isCustomRange){
       return (<span className={styles.dateformat}>{showCustomRange(startDatelist,endDatelist,"list",globalState)}</span>);
     }
  }
}
const handleSubmitFilter = () => {
  const tempData = {...globalState};
  if(listFilterLeagueId || listFilterStartDate || listFilterStartDateRange || valueradio){
    tempData.listTicketFilter.isFilter = true;
    tempData.listTicketFilter.clicked = true;
  }
  if(listFilterStartDateRange && listFilterEndDateRange){
    tempData.listTicketFilter.startdate = null;
    tempData.listTicketFilter.enddate = null;
    tempData.listTicketFilter.startDateRange = listFilterStartDateRange ? listFilterStartDateRange : globalState.listTicketFilter.startDateRange;
    tempData.listTicketFilter.endDateRange = listFilterEndDateRange ? listFilterEndDateRange : globalState.listTicketFilter.endDateRange;
  }else{
    if(days === 'Today' || days === 'Yesterday'){
      tempData.listTicketFilter.startdate = listFilterStartDate ? listFilterStartDate : globalState.listTicketFilter.startdate;
      tempData.listTicketFilter.enddate = null;
      tempData.listTicketFilter.startDateRange = null;
      tempData.listTicketFilter.endDateRange = null;
    }else {
      if(globalState.listTicketFilter.startDateRange && globalState.listTicketFilter.endDateRange){
         if(listFilterStartDate && listFilterEndDate){
          tempData.listTicketFilter.startdate = listFilterStartDate ? listFilterStartDate : globalState.listTicketFilter.startdate;
          tempData.listTicketFilter.enddate = listFilterEndDate ? listFilterEndDate : globalState.listTicketFilter.enddate ;
          tempData.listTicketFilter.startDateRange = null;
          tempData.listTicketFilter.endDateRange = null;
         }else{
          tempData.listTicketFilter.startdate = null;
          tempData.listTicketFilter.enddate = null;
          tempData.listTicketFilter.startDateRange = listFilterStartDateRange ? listFilterStartDateRange : globalState.listTicketFilter.startDateRange;
          tempData.listTicketFilter.endDateRange = listFilterEndDateRange ? listFilterEndDateRange : globalState.listTicketFilter.endDateRange;
         }
      }else{
        tempData.listTicketFilter.startdate = listFilterStartDate ? listFilterStartDate : globalState.listTicketFilter.startdate;
        tempData.listTicketFilter.enddate = listFilterEndDate ? listFilterEndDate : globalState.listTicketFilter.enddate ;
        tempData.listTicketFilter.startDateRange = null;
        tempData.listTicketFilter.endDateRange = null;
      }
    }   
  }
  tempData.listTicketFilter.leagueId = listFilterLeagueId;
  tempData.listTicketFilter.ticketStatus = valueradio ? valueradio : null;
  tempData.listTicketFilter.leagueName = listLeague;
  tempData.listTicketFilter.selectedDateValue = days;
  if(listFilterStartDateRange && listFilterEndDateRange){
  tempData.listTicketFilter.isCustomRange = true;
  }
  handleGlobalState(tempData);
  handleCloseFilterDropDown();
}

  return (
    <div className={styles.filterDropdownlist}>
      <div className={styles.top}>
        <FilterTitle handleCloseFilterDropDown={handleCloseFilterDropDown}/>
        <div className={styles.filterContainerlist}>
          <div className={styles.container}>
            <div className={styles.filterDetails}>
              <div className={styles.textFieldFullMain}>
                <div className={styles.titlePlaceholder}>
                  <b className={styles.event}>Event</b>
                </div>
                <div className={styles.textField} onClick={handleClickOpenMenu}>
                  <div className={styles.container1}>
                    <div
                      className={
                        listLeague === "" ? styles.select : styles.leagueSelect
                      }
                    >
                      {listLeague ? listLeague : '--Select--'}
                    </div>
                    <img
                      className={styles.sharpOutlineDropdown}
                      alt="dropdownIcon"
                      src={dropdownIcon}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.listStatus}>
                <div>
                  <b className={styles.listStatus1}>Status</b>
                </div>
                <div
                  className={styles.radiogroup}
                >
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={valueradio}
                    onChange={handleChangeValidate}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div>
                      <FormControlLabel
                        value = 'List'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              },              
                            }}
                            data-testid ={`one`}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radioListed}>Listed</span>
                    </div>
                    <div>
                      <FormControlLabel
                        value = 'DelistInProgress'
                        control={
                          <Radio
                            sx={{
                              color: "#B9BDC6",
                              "&.Mui-checked": {
                                color: "#5D75F8",
                              }
                            }}
                            data-testid ={`two`}
                          />
                        }
                        label=""
                      />
                      <span className={styles.radioDelistRequestListTab}>Delist Requested</span>
                    </div>
                  </RadioGroup>
                </div>
              </div>
              <DateFilter 
                handleClickDays={handleClickDays}
                showDayTick={showDayTick} 
                handleClickCustomRange={handleClicklistCustomRange}
                showCustomRangeValues={showCustomRangeValues} 
                showDatePicker={showDatePickerlist} 
                startDate={startDatelist}
                endDate={endDatelist}
                handleClickOutside={handleClicklistDatePickerOutside} 
                onChange={listDatePickerChange}
              />
            </div>
          </div>
          <ResetApplyButtons handleCancel={handleCancel} handleSubmit= {handleSubmitFilter}/>
        </div>
      </div>
       <LeagueListMenu
        anchorEl ={anchorEl}
        open= {open}
        selectedLeague = {listLeague}
        handleCloseMenu ={handleCloseMenu}
        handleSelectleague={handleSelectleague}
        leagueslistData = {leagueslistDataInlist}
      />
    </div>
  );
};

export default ListTicketFilterDropdown;
